<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'

const { t } = useI18n()
</script>

<template>
  <div class="min-h-screen bg-[var(--color-bg)] text-[var(--color-text-primary)]">
    <a href="#main-content" class="skip-link">{{ t('common.skipToContent') }}</a>
    <AppHeader />
    <main id="main-content" class="mx-auto max-w-7xl px-4 py-6">
      <router-view />
    </main>
    <AppFooter />
  </div>
</template>
